import {Button} from '@/components/ui/button/Button'
import styled, {css} from 'styled-components'

export const StyledGenerateButton = styled(Button)(
    ({theme: {palette, spacing}}) => css`
        color: ${palette.primary[500]};
        margin-right: ${spacing}px;
    `
)
